import { ButtonV2 } from '@labrav/react-components'
import { FormikProps } from 'formik'
import { KeyWordMap } from './AddEditKeywords'
import { useDispatch, useSelector } from '../../../store'
import { KeywordCompetitorMapping } from '../../../modules/mpsSeo/reducer'
import { removeKeywordCompetitor } from '../../../modules/mpsSeo/action'
import { KeywordMapping } from './KeywordMapping'
import { useStyles } from './AddEditKeywords.styles'
import { SEO_CLOUD_MARKETPLACE, useSeoAccountId } from '../seoCloud'

export const AddEditKeywordsList = ({
  push,
  remove,
  formikProps,
}: {
  push: <X = any>(obj: X) => void
  remove?: <X = any>(index: number) => X | undefined
  formikProps: FormikProps<{
    keywordCompetitorMapping: KeyWordMap[]
  }>
}) => {
  const { classes } = useStyles()
  const dispatch = useDispatch()
  const selectedCloud = SEO_CLOUD_MARKETPLACE
  const accountId = useSeoAccountId()
  const keywordCompetitorList = useSelector<KeywordCompetitorMapping[]>(
    state => state.marketplaceSeo[selectedCloud].keywordCompetitorMapping
  )
  const { values, setFieldValue } = formikProps
  const handleDelete = async (index: number) => {
    if (remove) {
      await remove(index)
    }

    const updatedValues = values.keywordCompetitorMapping.filter(
      (item, idx) => idx !== index
    )
    await setFieldValue('keywordCompetitorMapping', updatedValues)

    if (keywordCompetitorList?.length > index && accountId) {
      await dispatch(
        removeKeywordCompetitor({
          keywordCompetitor: values.keywordCompetitorMapping[index],
          partnerId: accountId,
          cloudMarketplace: selectedCloud,
        })
      )
    }
  }
  return (
    <>
      {values?.keywordCompetitorMapping?.map((item, index) => (
        <KeywordMapping
          keywords={item?.keywords}
          competitors={item?.competitors}
          handleDelete={handleDelete}
          index={index}
          formikProps={formikProps}
        />
      ))}

      {values?.keywordCompetitorMapping?.length < 5 && (
        <ButtonV2
          styleType="link"
          className={classes.addKeyword}
          onClick={() => {
            push({ keywords: [], competitors: [] })
          }}
          data-testid="track-more-keywords"
        >
          Add more keywords and competitors to track
        </ButtonV2>
      )}
      {values?.keywordCompetitorMapping?.length >= 5 && (
        <div className={classes.maxLimitMessage}>
          Maximum limit of 5 keywords tracking has reached
        </div>
      )}
    </>
  )
}
